import type { IconData } from '@stacksjs/iconify-core'

export const mm4x3: IconData = {
  "body": "<path fill=\"#fecb00\" d=\"M0 0h640v480H0z\"/><path fill=\"#34b233\" d=\"M0 160h640v320H0z\"/><path fill=\"#ea2839\" d=\"M0 320h640v160H0z\"/><g transform=\"translate(320 256.9)scale(176.87999)\"><path id=\"SVGOCbpRbuG\" fill=\"#fff\" d=\"m0-1l.3 1h-.6z\"/><use width=\"100%\" height=\"100%\" href=\"#SVGOCbpRbuG\" transform=\"rotate(-144)\"/><use width=\"100%\" height=\"100%\" href=\"#SVGOCbpRbuG\" transform=\"rotate(-72)\"/><use width=\"100%\" height=\"100%\" href=\"#SVGOCbpRbuG\" transform=\"rotate(72)\"/><use width=\"100%\" height=\"100%\" href=\"#SVGOCbpRbuG\" transform=\"rotate(144)\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default mm4x3
